// Mock Analytics Data
// Extracted from AdvancedAnalytics.tsx

export interface AnalyticsData {
  overview: {
    total_revenue: number;
    total_sessions: number;
    total_clients: number;
    average_rating: number;
    revenue_growth: number;
    session_growth: number;
    client_growth: number;
    rating_change: number;
  };
  revenue: {
    monthly: { month: string; revenue: number }[];
    by_session_type: { type: string; revenue: number; sessions: number }[];
    by_client_tier: { tier: string; revenue: number; clients: number }[];
  };
  sessions: {
    monthly: { month: string; sessions: number }[];
    by_type: { type: string; count: number; revenue: number }[];
    by_duration: { duration: string; count: number; avg_rating: number }[];
    completion_rate: number;
    cancellation_rate: number;
  };
  clients: {
    new_clients: { month: string; count: number }[];
    retention_rate: number;
    average_lifetime_value: number;
    by_demographic: { demographic: string; count: number; revenue: number }[];
  };
  content: {
    total_views: number;
    total_likes: number;
    total_purchases: number;
    by_type: { type: string; views: number; likes: number; purchases: number }[];
    top_performing: { title: string; views: number; revenue: number }[];
  };
  performance: {
    response_time: number;
    availability_rate: number;
    client_satisfaction: number;
    repeat_client_rate: number;
  };
}

export const mockAnalytics: AnalyticsData = {
  overview: {
    total_revenue: 15420,
    total_sessions: 89,
    total_clients: 23,
    average_rating: 4.7,
    revenue_growth: 12.5,
    session_growth: 8.3,
    client_growth: 15.2,
    rating_change: 0.2
  },
  revenue: {
    monthly: [
      { month: 'Jan', revenue: 1200 },
      { month: 'Feb', revenue: 1350 },
      { month: 'Mar', revenue: 1420 },
      { month: 'Apr', revenue: 1580 },
      { month: 'May', revenue: 1650 },
      { month: 'Jun', revenue: 1720 }
    ],
    by_session_type: [
      { type: 'Consultation', revenue: 8200, sessions: 45 },
      { type: 'Follow-up', revenue: 4200, sessions: 28 },
      { type: 'Emergency', revenue: 3020, sessions: 16 }
    ],
    by_client_tier: [
      { tier: 'Premium', revenue: 9200, clients: 8 },
      { tier: 'Standard', revenue: 5200, clients: 12 },
      { tier: 'Basic', revenue: 1020, clients: 3 }
    ]
  },
  sessions: {
    monthly: [
      { month: 'Jan', sessions: 12 },
      { month: 'Feb', sessions: 14 },
      { month: 'Mar', sessions: 15 },
      { month: 'Apr', sessions: 16 },
      { month: 'May', sessions: 17 },
      { month: 'Jun', sessions: 18 }
    ],
    by_type: [
      { type: 'Video Call', count: 45, revenue: 8200 },
      { type: 'In-Person', count: 28, revenue: 4200 },
      { type: 'Phone Call', count: 16, revenue: 3020 }
    ],
    by_duration: [
      { duration: '30 min', count: 25, avg_rating: 4.6 },
      { duration: '60 min', count: 45, avg_rating: 4.8 },
      { duration: '90 min', count: 19, avg_rating: 4.9 }
    ],
    completion_rate: 94.2,
    cancellation_rate: 5.8
  },
  clients: {
    new_clients: [
      { month: 'Jan', count: 3 },
      { month: 'Feb', count: 4 },
      { month: 'Mar', count: 5 },
      { month: 'Apr', count: 3 },
      { month: 'May', count: 4 },
      { month: 'Jun', count: 4 }
    ],
    retention_rate: 87.5,
    average_lifetime_value: 670,
    by_demographic: [
      { demographic: '25-34', count: 8, revenue: 5200 },
      { demographic: '35-44', count: 10, revenue: 6800 },
      { demographic: '45-54', count: 5, revenue: 3400 }
    ]
  },
  content: {
    total_views: 15420,
    total_likes: 892,
    total_purchases: 156,
    by_type: [
      { type: 'Articles', views: 8200, likes: 450, purchases: 89 },
      { type: 'Videos', views: 5200, likes: 320, purchases: 45 },
      { type: 'Courses', views: 2020, likes: 122, purchases: 22 }
    ],
    top_performing: [
      { title: 'Diabetes Management Guide', views: 1200, revenue: 450 },
      { title: 'Nutrition Fundamentals', views: 980, revenue: 320 },
      { title: 'Stress Reduction Techniques', views: 850, revenue: 280 }
    ]
  },
  performance: {
    response_time: 2.3,
    availability_rate: 95.8,
    client_satisfaction: 4.7,
    repeat_client_rate: 78.3
  }
}; 